import "./assets/styles/qrValidator.scss"

import { useEffect, useRef, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { Spinner } from "react-bootstrap"

import QrValidatorState from "./interfaces/QrValidatorState"
import QrValidatorController from "./controller/QrValidatorController"
import {useTranslation} from "react-i18next";

export default function QrValidator() {
    const [searchParams] = useSearchParams()
    const {t} = useTranslation()
    const validationUrl = searchParams.get("validation_url")

    const [state, setState] = useState<QrValidatorState>({
        loading: true,
    })

    const requestedUrl = useRef<string | null>(null)

    useEffect(() => {
        if (!validationUrl) {
            setState({
                loading: false,
                found: false,
                availability: false,
            })

            return
        }

        // Prevent requesting a one-time token more than once
        if (requestedUrl.current === validationUrl) {
            return
        }

        requestedUrl.current = validationUrl

        const controller = new QrValidatorController(
            state,
            setState
        )

        controller.init(validationUrl).then()
    }, [validationUrl])

    if (state.loading) {
        return (
            <section className="qr-validator-container">
                <div className="qr-validate-description">
                    <div className="loading">
                        <Spinner />
                        <p>{t("qr.acceptWaitingText")}</p>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section className="qr-validator-container"  style={{ background: state.color }}>
            <div className="qr-validate-description">
                <img
                    src={state.image}
                    alt={t("qr.barcodeStatus")}
                />

                <div className="title">
                    <h1>{state.title ? t(state.title.message) : t("qr.default.message")}</h1>
                    <p>{state.title ? t(state.title.description) : t("qr.default.description")}</p>
                </div>
            </div>
        </section>
    )
}